import $ from 'jquery';

const EDITOR_CONTAINER_ID = '#post-editor-content'

const dragToUpload = (handleFiles) => {
    window.addEventListener('dragover', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.dataTransfer.types && Array.from(e.dataTransfer.types).includes('Files')) {
            $('.editor-wrapper').addClass('drag');
        }
    }, false);
    window.addEventListener('dragleave', (e) => {
        e.preventDefault();
        e.stopPropagation();
        $('.editor-wrapper').removeClass('drag');
    }, false);
    window.addEventListener('drop', (e) => {
        e.preventDefault();
        const files = e.dataTransfer && e.dataTransfer.files;
        const $target = $(e.target);
        if (files.length > 0 && $target.parents(EDITOR_CONTAINER_ID).length > 0) {
            handleFiles(files);
        }
        $('.editor-wrapper').removeClass('drag');
    }, false);
};

export default dragToUpload;
